import queryString from 'query-string'
import axios from 'axios'

import config from './config'
import errors from './errors'
import store from '@/store'
import router from '../router'
import auth from '@/services/auth'
import * as Sentry from '@sentry/vue'

const paramsSerializer = params => queryString.stringify(params)

const api = {
  accounts: axios.create({ baseURL: config.accountsUrl, paramsSerializer }),
  auth: axios.create({ baseURL: config.authUrl, paramsSerializer }),
  billing: axios.create({ baseURL: config.billingUrl, paramsSerializer }),
  nodes: axios.create({ baseURL: config.nodesUrl, paramsSerializer })
}

function setToken(token) {
  this.defaults.headers.common['Authorization'] = `Bearer ${token}`
  this.defaults.headers.common['Content-Type'] = 'application/json'
}

const requestInterceptor = {
  success: () => configuration => configuration,
  error: () =>
    function (err) {
      throw err
    }
}

const responseInterceptor = {
  success: () => res => Promise.resolve(res),

  error: () =>
    function (err) {
      const defaultMessage = 'Something went wrong.'
      let notification = { message: defaultMessage, type: 'error' }

      if (!err.response) {
        notification.message = `Something is wrong with our services, please try again.
      If the error persists, contact us at support@bloq.cloud.`
        Sentry.captureException(err)
      } else {
        if (err.response.status === 400) {
          notification.type = 'warning'
          notification.message =
            errors(err.response.data?.code) ||
            err.response.data.title ||
            defaultMessage
        } else {
          if (err.response.status === 401 || err.response.status === 403) {
            notification.type = 'warning'
            if (router.currentRoute.name === 'login') {
              /**
               * TODO: Use err.response.data.code
               * Currently when the email is correct but the password isn't,
               * the response has no error code.
               */
              if (err.response.data === 'NotVerified') {
                notification.message = errors(err.response.data)
              } else {
                notification.message = errors('InvalidCredentials')
              }
            } else {
              notification.message = errors('Timeout')
              auth.logout()
              router.push({ name: 'login' })
            }
          } else {
            notification.message =
              errors(err.response.data.code) || defaultMessage
            Sentry.captureException(err)
          }
        }
      }
      store.commit('addNotification', notification)
      return Promise.reject(err)
    }
}

api.accounts.setToken = setToken
api.billing.setToken = setToken
api.nodes.setToken = setToken

Object.keys(api).forEach(function (instance) {
  api[instance].interceptors.request.use(
    requestInterceptor.success(),
    requestInterceptor.error()
  )
  api[instance].interceptors.response.use(
    responseInterceptor.success(),
    responseInterceptor.error()
  )
})

export default api
